<template>
  <!-- Bootstrap и FontAwesome -->
  <i v-if="lib === 'bi' || lib === 'fa-solid'" :class="`${lib} ${icon}`"></i>
  <i v-else-if="lib === 'fa'" :class="`${lib}-solid ${icon}`"></i>

  <!-- Material Icons -->
  <span v-else-if="lib === 'material'" class="material-icons">
    {{ icon }}
  </span>

  <!-- Filoxenia Icons -->
  <FiloxeniaIcon v-else-if="lib === 'filoxenia'" :name="icon" />
</template>

<script lang="ts">
import FiloxeniaIcon from "@/components/common-ui/icons/FiloxeniaIcon.vue";
import { Options, Vue, prop } from "vue-class-component";

export type IconLib = "bi" | "fa" | "fa-solid" | "material" | "filoxenia";

class Props {
  icon = prop<string>({ required: true });
  lib = prop<IconLib>({ required: true });
}
@Options({ components: { FiloxeniaIcon } })
class IconComponent extends Vue.with(Props) {}
export default IconComponent;
</script>

<style lang="scss" scoped></style>
